module.exports = __webpack_public_path__ + "static/media/17.441de98d.png";